import { API_URL_VERSION } from "../constants/environment";
import api from "./api";
import { toSearchFilter } from "../utils";

export const ENDPOINT_DIGITAL_COLLECTIONS = API_URL_VERSION + 'recolhimentos-digitais';
export const ENDPOINT_DIGITAL_COLLECTIONS_DRV = ENDPOINT_DIGITAL_COLLECTIONS + "/drv";
export const ENDPOINT_DIGITAL_COLLECTIONS_DRV_LIST  = ENDPOINT_DIGITAL_COLLECTIONS_DRV + '/listar';

export const STATUS_LIST = [
    {
        status: "Não Regularizados",
        id: "NAO_REGULARIZADOS"
    },
    {
        status: "Regularizados",
        id: "REGULARIZADOS"
    }
];

export const DOCUMENT_TYPE_LIST = [
    {
        type: "DARV",
        id: "DARV"
    },
    {
        type: "DRV",
        id: "DRV"
    }
];

export const drvService = {
    list: async (params = {}) => {
        try {
            const response = await api.post(ENDPOINT_DIGITAL_COLLECTIONS_DRV_LIST, toSearchFilter(params));
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "digital-collections.drv.messages.errors.list";
        }
    }
};
